import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LoginTabs from "@/components/LoginTabs";
import { Helmet } from "react-helmet";

const Login = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Login - Ace Anchor Study Abroad</title>
        <meta name="description" content="Login to your Ace Anchor account. Access your study abroad dashboard for students or admin portal." />
      </Helmet>
      <Header />
      <main className="pt-20">
        <LoginTabs />
      </main>
      <Footer />
    </div>
  );
};

export default Login;
